export const DEFAULT_DELETED_STRING = 'deleted' as const;
export const DEFAULT_DELETED_NUMBER = 0 as const;
export const DEFAULT_DELETED_ARRAY = [];
